<template>
    <div class='goodsListWrap'>
        <div class='goodsSign'>
            <div class='goodsSignItem'>
                <svg t='1713410725237' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5108' width='128' height='128'><path d='M608 608m-384 0a384 384 0 1 0 768 0 384 384 0 1 0-768 0Z' fill='#CAE705' p-id='5109'></path><path d='M528 464h160a32 32 0 0 1 0 64h-192a32 32 0 0 1-32-32v-256a32 32 0 0 1 64 0v224z' fill='#2B82D8' p-id='5110'></path><path d='M512 928c229.76 0 416-186.24 416-416S741.76 96 512 96 96 282.24 96 512s186.24 416 416 416z m0 64C246.912 992 32 777.088 32 512S246.912 32 512 32s480 214.912 480 480-214.912 480-480 480z' fill='#2B82D8' p-id='5111'></path></svg>
                <div class='title-wrap'>
                    <span class='item-title'>准时保证</span>
                    <span class='item-contnet'>出单准时 | 揽收准时</span>
                </div>
            </div>
            <div class='goodsSignItem'>
                <svg t='1713411200381' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='11400' width='128' height='128'><path d='M146.85 173.985h674.579c22.94 0 40.479-17.539 40.479-40.479 0-22.935-17.538-40.473-40.479-40.473h-674.579c-22.934 0-40.473 17.539-40.473 40.473 0 22.939 17.539 40.479 40.473 40.479z' fill='#F6942A' p-id='11401'></path><path d='M248.039 421.754c0 63.412 52.619 116.024 117.38 116.024s118.722-51.265 118.722-116.024c0 63.412 52.621 116.024 117.38 116.024 64.762 0 117.374-51.265 117.374-116.024 0 38.334 19.235 72.717 49.050 93.921 11.556-1.697 23.373-2.589 35.401-2.589 29.078 0 56.954 5.14 82.774 14.555 41.12-18.041 70.231-58.325 70.231-105.888l-83.652-211.82h-779.813l-80.951 211.82c0 63.412 52.619 116.024 117.38 116.024 64.756 0 118.724-51.265 118.724-116.024z' fill='#F6942A' p-id='11402'></path><path d='M561.747 754.685c0-48.45 14.271-93.562 38.826-131.381-52.486-0.658-97.371-33.105-115.801-78.754-18.825 46.121-64.927 78.786-118.68 78.786-53.183 0-98.804-32.665-117.426-78.786-18.823 46.121-64.925 78.786-118.677 78.786-12.665 0-24.883-1.9-36.428-5.347v261.187c0 24.282 26.985 53.962 51.265 53.962h495.661c-48.385-44.18-78.741-107.769-78.741-178.453z' fill='#F6942A' p-id='11403'></path><path d='M803.016 543.23c-115.455 0-209.049 93.595-209.049 209.049s93.595 209.049 209.049 209.049 209.049-93.594 209.049-209.049-93.594-209.049-209.049-209.049zM948.399 773.424h-124.235v124.235h-42.293v-124.235h-124.235v-42.293h124.235v-124.235h42.293v124.235h124.235v42.293z' fill='#F6942A' p-id='11404'></path></svg>
                <div class='title-wrap'>
                    <span class='item-title'>海量商家</span>
                    <span class='item-contnet'>你想要的我们都有</span>
                </div>
            </div>
            <div class='goodsSignItem'>
                <svg t='1713416805777' class='icon' viewBox='0 0 1109 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='44412' width='128' height='128'><path d='M1.28 207.957333v546.56s8.106667 59.392 26.88 78.165334c18.773333 18.773333 53.589333 38.229333 53.589333 38.229333l384.256 104.96s34.304 10.154667 43.349334 5.802667c9.045333-4.266667 6.314667-17.237333 6.314666-17.237334v-616.106666L1.28 208.042667zM1108.906667 207.957333l-163.242667 44.544V489.813333l-107.52 29.184v-237.226666l-245.76 67.157333v565.162667s-1.365333 56.576 5.717333 66.730666c7.168 10.24 42.922667-4.096 42.922667-4.096l345.344-94.293333s72.96-19.114667 99.669333-45.909333c26.709333-26.709333 22.869333-139.52 22.869334-139.52V207.957333zM1106.944 151.04L584.533333 6.4S561.834667 1.024 554.069333 1.024c-7.765333 0-31.232 5.802667-31.232 5.802667l-161.28 44.544 557.056 150.528 188.330667-50.858667zM1.109333 151.04l552.789334 149.333333 217.6-58.709333-555.349334-150.101333z' fill='#a880f6' p-id='44413'></path></svg>
                <div class='title-wrap'>
                    <span class='item-title'>一件起发</span>
                    <span class='item-contnet'>任意商家皆适用</span>
                </div>
            </div>
            <div class='goodsSignItem'>
                <svg t='1713417117367' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='50506' width='128' height='128'><path d='M691.4 685.5L809 489l0.2-0.3c64.7-108.5 29.4-248.9-79-313.8s-248.9-29.7-313.9 78.6l-4.9-2.9c-108.5-65-249.1-29.6-314.1 78.9-65 108.5-29.6 249.1 78.9 314.1l4.9 2.9 191.6 114.7 201.4 120.5 117.3-196.2z' fill='#FFE2DE' p-id='50507'></path><path d='M782.5 756.8l125-125 0.2-0.2c68.9-69.1 68.8-180.9-0.2-249.9s-180.8-69-249.9-0.2l-3.1-3.1c-69.1-69.1-181-69.1-250.1 0s-69.1 181 0 250.1l3.1 3.1 121.9 121.9 128.1 128.1 125-124.8z' fill='#FF9D83' p-id='50508'></path></svg>
                <div class='title-wrap'>
                    <span class='item-title'>优质服务</span>
                    <span class='item-contnet'>尽力提供最好的服务</span>
                </div>
            </div>
            <div class='goodsSignItem'>
                <svg t='1713417073016' class='icon' viewBox='0 0 1145 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='47720' width='128' height='128'><path d='M220.456213 539.1808l0 391.8144c0 0 10.5632 25.08 35.6432 31.6864L599.505813 962.6816 599.505813 539.1744 220.456213 539.1744 220.456213 539.1808 220.456213 539.1808zM1037.688213 542.2944l0 388.7008c0 0-10.5632 25.08-35.6496 31.6864L660.193813 962.6816 660.193813 539.1744l377.4944 0L1037.688213 542.2944 1037.688213 542.2944zM1108.981013 318.4c-3.9632-27.7248-31.6816-35.6432-31.6816-35.6432l-117.4192 0c14.8128-10.9184 30.0256-26.5936 43.8816-49.0688 25.888-41.9872 26.3312-100.8496 1.1376-149.968C979.681813 34.5568 933.832213 4.1504 879.118613 0.3008c-26.6368-1.8752-52.6944 5.0368-77.488 20.544-19.512 12.2064-38.3312 29.8496-55.9184 52.4368-30.1744 38.7568-49.1376 82.2448-55.888 99.1504-0.8368 2.0944-2.4368 5.3632-3.4496 7.3312-18.2944-7.0944-39.632-11.5936-61.8688-10.712-0.4256 0.0176-0.8496 0.024-1.2688 0-21.832-1.176-42.9056 3.2624-61.0128 10.3872-5.832-17-62.5632-173.712-172.4448-173.712-116.1808 0-153.1488 85.5936-162.3936 117.2864l43.576 14.5184c0 0 21.1248-85.8112 112.2176-87.136 80.6448-1.1696 130.2448 122.8304 140.5632 151.312-11.1376 9.3056-17.712 18.8-17.712 25.8064 0 6.8992 5.3248 15.4816 15.0864 23.8368-98.4992 21.5568-150.3552-64.0752-307.5184-103.8-170.3008-25.744-213.0624 54.7808-213.0624 54.7808s-7.6496 40.8 34.8368 29.7136c67.3312-61.3936 164.3632-37.632 207.9312-23.7696 33.8384 10.7632 106.832 51.2688 173.2 74.488L180.843413 282.7632c0 0-27.7184 7.9184-31.68 35.6432 1.3184 31.688 0 142.5888 0 142.5888L599.505813 460.9952 599.505813 282.7632l0 0c1.5376-0.5808 0.1008-0.0192 1.5376-0.5808 9.8624 1.5248 12.3008 1.2432 23.456 1.2432 9.288 0 18.088-0.5504 26.3872-1.5376l-0.0064 0.8752 10.5248 0-1.2944 3.7008-0.032 19.2368 0.1184 0 0 155.2944 448.7808 0C1108.981013 460.9952 1107.662613 350.088 1108.981013 318.4L1108.981013 318.4 1108.981013 318.4zM720.056213 197.864c0.7056-1.3632 3.4688-6.7264 5.2752-11.2512 10.3056-25.7936 66.0368-154.1488 151.1056-148.1744 56.2 3.9504 83.288 41 94.432 62.7312 18.9312 36.888 19.0688 82.0816 0.3504 112.4496-35.888 58.2192-79.968 55.7312-83.3936 55.456l-0.7744-0.1312-184.3312-1.1616c26.0688-12.0512 40.2496-28.5872 40.2496-40.2752C742.968213 219.4384 734.344213 208.2752 720.056213 197.864L720.056213 197.864 720.056213 197.864zM624.501013 254.0576c-7.6624 0-14.5056-0.4064-20.6128-1.1312-0.1568-1.888-0.856-4.288-2.3184-7.3504-9.0496-18.8448-28.4192-9.9248-33.7872-6.9808-2.9184-3.432-4.3008-7.2-4.3008-11.088 0-13.9808 17.8368-25.2688 61.0192-25.2688 39.7872 0 64.968 11.288 64.968 25.2688C689.469013 241.488 667.688213 254.0576 624.501013 254.0576L624.501013 254.0576 624.501013 254.0576zM624.501013 254.0576' fill='#fe5875' p-id='47721'></path></svg>
                <div class='title-wrap'>
                    <span class='item-title'>推荐有礼</span>
                    <span class='item-contnet'>推荐好友还能赚钱哦</span>
                </div>
            </div>
        </div>
        <div class='goodsList'>
            <div class='signTitle'>热销商品</div>
            <div class='signTitleNext'>一起来购买吧</div>
            <div class='goodsListMain'>
                <ul class='goodsul' @click='to'>
                    <li class='goodsli' v-for='(item, index) in goodsData' v-bind:key='index'>
                        <img class='goodsImg' :src='item.goods_images' width='160' height='160'/>
                        <div class='right-area'>
                            <div>
                                <p class='goodsTitle'>{{  item.goods_name }}</p>
                                <div class='betweenArea'>
                                    <span class='goodsPrice'>¥{{ item.goods_price }}</span>
                                    <span class='goodsWeight'>{{ item.goods_weight }}g/件</span>
                                </div>
                            </div>
                            <div class='betweenArea'>
                                <span class='cityArea'>
                                    <svg t='1713420549431' class='miniicon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4270' width='128' height='128'><path d='M512 64c211.776 0 384 174.272 384 388.48a379.264 379.264 0 0 1-101.44 259.584l-219.456 280.64a79.872 79.872 0 0 1-126.208 0.512l-223.872-283.2A388.224 388.224 0 0 1 128 452.48C128 238.272 300.224 64 512 64z m195.456 375.04c0-107.904-87.296-195.776-194.56-195.776-51.776 0-100.544 20.544-137.152 57.728a196.48 196.48 0 0 0-56.832 139.072c0.384 107.904 87.68 195.84 194.496 195.84a189.44 189.44 0 0 0 137.152-57.728c36.672-37.12 56.896-86.592 56.896-139.072z m-82.56 0c0 30.336-11.52 58.624-32.448 79.872a110.08 110.08 0 0 1-79.04 33.344c-61.824 0-112-50.56-112-112.64 0-30.272 11.52-58.624 32.384-79.808 21.76-21.504 49.92-33.344 79.616-33.344 29.888 0 57.92 11.648 79.04 33.024 21.12 21.312 32.768 49.6 32.512 79.616z' fill='#51A9FF' p-id='4271'></path></svg>
                                    <span>{{ item.type == 2 ? '广州市' : '合肥市' }}</span>
                                </span>
                                <span class='express'>{{ item.type == 2 ? '广州申通' : '江苏韵达' }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="moreGoods" @click='to'>点击查看更多商品>></div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      goodsData: [
        {
          goods_name: '徽仓专供东北大米生态基地东北大米500g×5袋',
          goods_images: 'https://images.haoliyuncang.com/20231205/4168a4af-6f72-4c50-aa61-56705e5e9d82.jpg?x-oss-process=image/quality,q_30&/a4af-6f72-4c50-aa61-56705e5e9d82',
          goods_price: '15.50',
          goods_weight: 500
        },
        {
          goods_name: '加恩贝正宗东北珍珠米大米700g×4袋生态基地东北大米珍珠米',
          goods_images: 'https://images.haoliyuncang.com/20231205/716d5a24-fcd1-4fb2-9843-52bc12dc697f.jpg?x-oss-process=image/quality,q_30&/5a24-fcd1-4fb2-9843-52bc12dc697f',
          goods_price: '14.9',
          goods_weight: 700
        },
        {
          goods_name: '小苏打【赠品】清洁剂去污',
          goods_images: 'http://ahc.1688dxb.com/uploadfile/temp/20230921/1695286192T6Q.jpg',
          goods_price: '0.1',
          goods_weight: 10
        },
        {
          goods_name: '洁厕宝一个装清洁去污马桶去污',
          goods_images: 'https://images.haoliyuncang.com/20240302/8d209a0d-6eae-4bba-8ae1-73ddaa5e7e7f.webp',
          goods_price: '0.3',
          goods_weight: 10
        },
        {
          goods_name: '透明挂钩一个装墙面挂钩',
          goods_images: 'https://images.haoliyuncang.com/20240408/9806130d-969f-4923-bf2d-78fd6a745a0f.jpg?x-oss-process=image/quality,q_30&/9806130d-969f-4923-bf2d-78fd6a745a0f',
          goods_price: '0.4',
          goods_weight: 10
        },
        {
          goods_name: '小孔雀湿巾一包【10片装】家庭装抽取式实惠装',
          goods_images: 'https://images.haoliyuncang.com/20240408/46433364-8309-4442-9c1c-4fcab103664b.png?x-oss-process=image/quality,q_30&/46433364-8309-4442-9c1c-4fcab103664b',
          goods_price: '0.4',
          goods_weight: 10
        },
        {
          goods_name: '徽仓原生抽纸【十包装】大包餐巾宿舍加厚家庭装抽取式实惠装面巾纸',
          goods_images: 'https://images.haoliyuncang.com/20231205/b33e4ac0-8e20-4e37-911a-0d7383f2febe.jpg?x-oss-process=image/quality,q_30&/4ac0-8e20-4e37-911a-0d7383f2febe',
          goods_price: '5.7',
          goods_weight: 100
        },
        {
          goods_name: '节庆红包5包通用新年红包利是封过年磨砂烫金红包壳春节送礼',
          goods_images: 'https://images.haoliyuncang.com/20240110/116352c1-36ac-4218-a25f-72fe23c90d1e.jpg?x-oss-process=image/quality,q_30&/116352c1-36ac-4218-a25f-72fe23c90d1e',
          goods_price: '7.3',
          goods_weight: 100
        },
        {
          goods_name: '压力小腿袜女夏季薄款韩版长筒袜纯棉显瘦白色袜子',
          goods_images: 'https://images.haoliyuncang.com/20231218/fc3f2bf9-2a3e-4c73-8245-52493f33f4bb.jpg?x-oss-process=image/quality,q_30&/fc3f2bf9-2a3e-4c73-8245-52493f33f4bb',
          goods_price: '3.85',
          goods_weight: 100
        },
        {
          goods_name: '中性笔一支超长书写',
          goods_images: 'https://images.haoliyuncang.com/20240416/b0b98141-1706-48d1-b8d4-33592b3d533f.jpg?x-oss-process=image/quality,q_30&/b0b98141-1706-48d1-b8d4-33592b3d533f',
          goods_price: '0.3',
          goods_weight: 100,
          type: 2
        },
        {
          goods_name: '小湿巾一包一次性湿巾',
          goods_images: 'https://images.haoliyuncang.com/20240416/17aca69a-87d9-4e51-9041-32430e35750a.jpg?x-oss-process=image/quality,q_30&/17aca69a-87d9-4e51-9041-32430e35750a',
          goods_price: '0.4',
          goods_weight: 100,
          type: 2
        },
        {
          goods_name: '沐碧小旅包抽纸耐用',
          goods_images: 'https://images.haoliyuncang.com/20240416/f58b2c8c-54d0-4f35-acca-7bdcb903189c.jpg?x-oss-process=image/quality,q_30&/f58b2c8c-54d0-4f35-acca-7bdcb903189c',
          goods_price: '0.4',
          goods_weight: 100,
          type: 2
        },
        {
          goods_name: '全金属旋转手机支架桌面ipad平板万能通用支撑架多功能折叠直播专用铝合金创意懒人手机架支架',
          goods_images: 'https://images.haoliyuncang.com/20231218/29dee984-1566-4937-b69f-457d8385f9e4.jpg?x-oss-process=image/quality,q_30&/29dee984-1566-4937-b69f-457d8385f9e4',
          goods_price: '3.80',
          goods_weight: 100
        },
        {
          goods_name: '婴儿湿纸巾一提8包小包装带盖宝宝新生儿手口屁纸巾小黄鸡一次性湿巾',
          goods_images: 'https://images.haoliyuncang.com/20231218/195336b1-aee1-469c-87ac-0c2fe2ca0809.jpg?x-oss-process=image/quality,q_30&/195336b1-aee1-469c-87ac-0c2fe2ca0809',
          goods_price: '3.7',
          goods_weight: 100
        },
        {
          goods_name: '徽仓原生抽纸【六包装】大包餐巾宿舍加厚家庭装抽取式实惠装面巾纸',
          goods_images: 'https://images.haoliyuncang.com/20231218/28028f12-e97b-4686-918e-aa4bb8babc3b.jpg?x-oss-process=image/quality,q_30&/28028f12-e97b-4686-918e-aa4bb8babc3b',
          goods_price: '3.6',
          goods_weight: 100
        },
        {
          goods_name: '光明一次性手套加厚三包装【一包100只】塑料薄膜中号',
          goods_images: 'https://images.haoliyuncang.com/20231219/23a157d5-5358-4aa5-87e1-745c62888c20.jpg?x-oss-process=image/quality,q_30&/23a157d5-5358-4aa5-87e1-745c62888c20',
          goods_price: '3.25',
          goods_weight: 100
        },
        {
          goods_name: '精品中筒袜子五双女夏季薄款韩版长筒袜纯棉显瘦白色袜子',
          goods_images: 'https://images.haoliyuncang.com/20231205/7b9c973f-44ac-4146-9b0a-f399c6d9c00e.jpg?x-oss-process=image/quality,q_30&/973f-44ac-4146-9b0a-f399c6d9c00e',
          goods_price: '3.6',
          goods_weight: 100
        },
        {
          goods_name: '清风手帕纸一条餐巾纸小包随身装便携式面巾纸巾',
          goods_images: 'https://images.haoliyuncang.com/20231218/4a60d44c-d650-4a0c-9eaf-03ef29b748be.png?x-oss-process=image/quality,q_30&/4a60d44c-d650-4a0c-9eaf-03ef29b748be',
          goods_price: '3.20',
          goods_weight: 100
        },
        {
          goods_name: '干发帽女超强吸水速干加厚2024新款包头擦头毛巾洗头浴帽',
          goods_images: 'https://images.haoliyuncang.com/20231218/06693a65-f105-44bc-be8b-7aadb08db759.jpg?x-oss-process=image/quality,q_30&/06693a65-f105-44bc-be8b-7aadb08db759',
          goods_price: '3.1',
          goods_weight: 100
        },
        {
          goods_name: '加恩倍洗脸巾【二包】全棉加大加厚无螨一次性擦脸巾',
          goods_images: 'https://images.haoliyuncang.com/20231218/0faa505c-7d24-46f6-a1cb-a5f206c3857c.png?x-oss-process=image/quality,q_30&/0faa505c-7d24-46f6-a1cb-a5f206c3857c',
          goods_price: '3.00',
          goods_weight: 100
        },
        {
          goods_name: '彩色便利贴三个装可撕无粘性便携记事办公室笔记',
          goods_images: 'https://images.haoliyuncang.com/20231219/566c5be2-670c-41cb-9241-10e465ac2e0b.jpg?x-oss-process=image/quality,q_30&/566c5be2-670c-41cb-9241-10e465ac2e0b',
          goods_price: '3.00',
          goods_weight: 100
        },
        {
          goods_name: '徽仓冰袖四双冰爽防晒袖套女夏骑行防紫外线',
          goods_images: 'https://images.haoliyuncang.com/20231218/743f73af-5b3b-40bc-8b4f-bddf265ad490.jpg?x-oss-process=image/quality,q_30&/743f73af-5b3b-40bc-8b4f-bddf265ad490',
          goods_price: '2.90',
          goods_weight: 100
        },
        {
          goods_name: '涪陵榨菜8包装',
          goods_images: 'https://images.haoliyuncang.com/20231219/71d50fc5-d384-491e-8ff6-9bceb2e65b6b.jpg?x-oss-process=image/quality,q_30&/71d50fc5-d384-491e-8ff6-9bceb2e65b6b',
          goods_price: '2.70',
          goods_weight: 100
        },
        {
          goods_name: '鸡精4包鸡精味精家用厨房调料鲜鸡汁调味料',
          goods_images: 'https://images.haoliyuncang.com/20231218/75316faa-c43e-4711-8377-28f7cb7747dd.jpg?x-oss-process=image/quality,q_30&/75316faa-c43e-4711-8377-28f7cb7747dd',
          goods_price: '2.60',
          goods_weight: 100
        },
        {
          goods_name: '粉色造型梳女士专用长发高颅顶蓬松头发按摩造型神器卷',
          goods_images: 'https://images.haoliyuncang.com/20231218/3f580a41-2f94-41f2-8a44-7f1a94ca197a.jpg?x-oss-process=image/quality,q_30&/3f580a41-2f94-41f2-8a44-7f1a94ca197a',
          goods_price: '2.60',
          goods_weight: 100
        },
        {
          goods_name: '徽仓10支装牙刷成人家用家庭装情侣旅行',
          goods_images: 'https://images.haoliyuncang.com/20231218/70b0db4c-600e-40e1-96c2-568d0a6c0309.jpg?x-oss-process=image/quality,q_30&/70b0db4c-600e-40e1-96c2-568d0a6c0309',
          goods_price: '2.50',
          goods_weight: 100
        },
        {
          goods_name: '牙线50支三盒装细滑家庭装剔牙牙线一次性',
          goods_images: 'https://images.haoliyuncang.com/20240225/f8b48641-758f-435b-ad04-e1b97a68aa14.jpg?x-oss-process=image/quality,q_30&/f8b48641-758f-435b-ad04-e1b97a68aa14',
          goods_price: '2.45',
          goods_weight: 100
        },
        {
          goods_name: '棉签5包双头一次性竹棒棉签掏耳朵',
          goods_images: 'https://images.haoliyuncang.com/20231218/d5efa9c0-4593-41b3-aaa8-577d189e60a7.jpg?x-oss-process=image/quality,q_30&/d5efa9c0-4593-41b3-aaa8-577d189e60a7',
          goods_price: '2.45',
          goods_weight: 100
        },
        {
          goods_name: '小黄鸭牙刷刮舌器刮舌头神器儿童刮舌苔清洁器成人',
          goods_images: 'https://images.haoliyuncang.com/20231218/2c547178-0973-49a7-a074-bbc9a13c2dc4.jpg?x-oss-process=image/quality,q_30&/2c547178-0973-49a7-a074-bbc9a13c2dc4',
          goods_price: '2.4',
          goods_weight: 100
        },
        {
          goods_name: '桶装发圈【二桶】橡皮筋女扎头发绳皮套高弹力',
          goods_images: 'https://images.haoliyuncang.com/20231218/321858f8-4370-4877-928c-7fb81f4b7e3f.jpg?x-oss-process=image/quality,q_30&/321858f8-4370-4877-928c-7fb81f4b7e3f',
          goods_price: '2.30',
          goods_weight: 100
        },
        {
          goods_name: '记号笔【十支】耐酒精抗酒精记号笔油性笔',
          goods_images: 'https://images.haoliyuncang.com/20231218/67abd966-05b4-4d73-a784-4122a6b35432.png?x-oss-process=image/quality,q_30&/67abd966-05b4-4d73-a784-4122a6b35432',
          goods_price: '2.20',
          goods_weight: 100
        },
        {
          goods_name: '剪刀一个家用裁衣裁剪刀大剪子',
          goods_images: 'https://images.haoliyuncang.com/20231218/8e76f75f-5729-4e08-9a7a-96a979fa6921.png?x-oss-process=image/quality,q_30&/8e76f75f-5729-4e08-9a7a-96a979fa6921',
          goods_price: '2.20',
          goods_weight: 100
        },
        {
          goods_name: '留香珠持久香味100天护衣增香柔顺洗衣香珠',
          goods_images: 'https://images.haoliyuncang.com/20231218/42e9c885-5966-4a52-beb5-840bfe29ae38.jpg?x-oss-process=image/quality,q_30&/42e9c885-5966-4a52-beb5-840bfe29ae38',
          goods_price: '2.20',
          goods_weight: 100
        },
        {
          goods_name: '驱蚊贴三包随身驱蚊神器防蚊子',
          goods_images: 'https://images.haoliyuncang.com/20231218/3b50d463-da8e-4db0-b7e5-c277090a6772.jpg?x-oss-process=image/quality,q_30&/3b50d463-da8e-4db0-b7e5-c277090a6772',
          goods_price: '1.90',
          goods_weight: 100
        },
        {
          goods_name: '冰凉贴3包夏季冰凉贴降温神器冰贴解暑',
          goods_images: 'https://images.haoliyuncang.com/20231218/383d5d60-9871-4349-8c41-c7c0f4e54b34.jpg?x-oss-process=image/quality,q_30&/383d5d60-9871-4349-8c41-c7c0f4e54b34',
          goods_price: '1.65',
          goods_weight: 100
        },
        {
          goods_name: '一次性PE保鲜膜【50只】一包装',
          goods_images: 'https://images.haoliyuncang.com/20231219/2dc23023-dd17-4119-b09f-0cbd4b912183.png?x-oss-process=image/quality,q_30&/2dc23023-dd17-4119-b09f-0cbd4b912183',
          goods_price: '1.25',
          goods_weight: 100
        }
      ]
    }
  },
  created () {
    this.goodsData = this.goodsData.sort((a, b) => a.goods_price - b.goods_price)
  },
  methods: {
    to () {
      this.$router.push('/orderAdmin/purchase')
    }
  }
}
</script>

<style scoped>
    .goodsListWrap{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #efefef;
        padding: 0 20px 20px;
        flex-direction: column;
    }
    .goodsSign{
        width: 1200px;
        background: #FFf;
        border-radius: 15px 15px 0 0;
        padding: 20px;
        display: flex;
        align-items: center;
    }
    .goodsList{
        width: 1200px;
        background: #FFf;
        border-radius: 0 0 15px 15px;
        padding:0 20px 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .goodsSignItem{
        display: flex;
        width: 25%;
        align-items: center;
    }
    .title-wrap{
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .icon{
        width: 40px;
        height: 40px;
        margin: 10px 20px;
    }
    .item-title{
        font-size: 16px;
        color: #1c1f21;
    }
    .item-contnet{
        font-size: 12px;
        margin-top: 10px;
        color: #9199a1;
    }
    .signTitle{
        font-size: 20px;
        color: #333;
        font-weight: 500;
        text-align: center;
        width: 100%;
    }
    .signTitleNext{
        font-size: 16px;
        color: #666;
        font-weight: 400;
        text-align: center;
        width: 100%;
        margin-top:  10px 0  15px;
    }
    .goodsListMain{
        margin-top: 20px;
    }
    .goodsul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .goodsli{
        display: flex;
        align-items: center;
        box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2);
        transition: all 0.5s ease-in;
        background: #f7f9fa;
        width: 30%;
        margin-bottom: 30px;
        padding: 12px;
        border-radius: 15px;
    }
    .goodsli:hover {
        box-shadow: 10px 10px 10px 3px rgba(0, 0, 0, 0.2);
    }
    .right-area{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    .goodsImg{
        width: 160px;
        height: 160px;
        margin-right: 15px;
        border-radius: 15px;
        min-width: 160px;
    }
    .goodsTitle{
        color: rgb(71 85 105);
        font-size: 16px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .betweenArea{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        align-items: center;
    }
    .goodsPrice{
        font-size: 18px;
        color: rgb(234 88 12);
    }
    .goodsWeight{
        font-size: 16px;
        color: rgb(82 82 82);
    }
    .cityArea{
        font-size: 14px;
        font-weight: 300;
        display: flex;
        align-items: center;
    }
    .miniicon{
        font-size: 12px;
        width: 15px;
        height: 30px;
    }
    .express{
        font-size: 14px;
        color: #333;
    }
    .moreGoods{
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #333;
      cursor: pointer;
    }
</style>
